const rankingItems = [
  { rank: 1, title: '某顶流塌房事件全记录', views: '128万', tag: '爆', tagColor: 'bg-primary-500 text-background-50' },
  { rank: 2, title: '网红圈连环爆料大合集', views: '96万', tag: '热', tagColor: 'bg-accent-500 text-background-50' },
  { rank: 3, title: '综艺节目黑幕深度解析', views: '74万', tag: '热', tagColor: 'bg-accent-500 text-background-50' },
  { rank: 4, title: '饭圈集资乱象调查', views: '63万', tag: '', tagColor: '' },
  { rank: 5, title: '直播圈大佬恩怨始末', views: '58万', tag: '', tagColor: '' },
  { rank: 6, title: '音乐节假唱实锤汇总', views: '51万', tag: '新', tagColor: 'bg-secondary-500 text-background-50' },
  { rank: 7, title: '某女星合约风波追踪', views: '45万', tag: '', tagColor: '' },
];

export default function RankingSection() {
  const getRankStyle = (rank: number) => {
    if (rank === 1) return 'bg-primary-500 text-background-50';
    if (rank === 2) return 'bg-primary-400 text-background-50';
    if (rank === 3) return 'bg-primary-300 text-primary-800';
    return 'bg-background-200 text-foreground-500';
  };

  return (
    <section id="ranking" className="scroll-mt-20 py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-6xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-xl md:text-3xl font-bold text-foreground-950 font-heading">吃瓜热榜</h2>
          <p className="mt-2 text-sm text-foreground-500">大家都在看的深度好瓜</p>
        </div>
        <div className="max-w-2xl mx-auto space-y-2">
          {rankingItems.map((item) => (
            <div
              key={item.rank}
              className="flex items-center gap-4 p-4 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all cursor-pointer group"
            >
              <span className={`w-8 h-8 flex items-center justify-center rounded-lg text-sm font-bold flex-shrink-0 ${getRankStyle(item.rank)}`}>
                {item.rank}
              </span>
              <span className="flex-1 text-sm font-semibold text-foreground-800 truncate group-hover:text-primary-500 transition-colors">
                {item.title}
              </span>
              {item.tag && (
                <span className={`text-xs px-2 py-0.5 rounded font-medium whitespace-nowrap ${item.tagColor}`}>
                  {item.tag}
                </span>
              )}
              <span className="text-xs text-foreground-400 whitespace-nowrap">{item.views} 阅读</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}